import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1254.000000 1254.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)">

<path d="M6278 10510 c-3 -14 -25 -131 -49 -261 l-42 -237 21 -27 c47 -59 12
-161 -60 -179 -109 -27 -160 86 -102 227 54 132 48 231 -17 292 -25 23 -30 26
-24 10 4 -11 10 -46 13 -77 4 -54 1 -65 -54 -180 -52 -108 -59 -130 -59 -183
0 -114 74 -195 185 -203 33 -2 74 1 91 7 41 14 49 4 49 -61 l0 -47 29 10 c21
7 36 7 50 -1 22 -11 25 -8 21 23 -1 10 4 34 10 53 9 27 16 34 29 28 9 -4 43
-9 77 -12 72 -5 123 16 172 73 39 43 45 68 40 148 -3 50 -13 81 -56 166 -45
89 -52 111 -52 161 0 32 4 70 10 84 12 32 4 33 -22 4 -65 -75 -71 -141 -24
-276 20 -56 36 -116 36 -133 0 -85 -81 -141 -155 -107 -54 25 -72 115 -35 175
l20 33 -45 247 c-52 286 -50 276 -57 243z"/>
<path d="M6264 9475 c-23 -36 -80 -191 -93 -257 -19 -91 5 -150 78 -188 32
-16 83 -5 115 27 31 31 50 93 40 136 -22 105 -98 307 -115 307 -5 0 -16 -11
-25 -25z"/>
<path d="M5676 9482 c-50 -2 -96 -8 -103 -14 -17 -14 -16 -33 3 -52 13 -14 53
-16 284 -16 l268 0 13 38 c7 20 11 39 11 42 -2 5 -331 7 -476 2z"/>
<path d="M6663 9482 l-251 -2 15 -40 16 -40 267 0 c282 0 290 1 290 47 0 38
-7 39 -337 35z"/>
<path d="M5570 9270 c-8 -14 -8 -26 0 -40 10 -19 21 -20 260 -20 231 0 250 1
250 18 0 9 3 27 6 40 l6 22 -255 0 c-246 0 -257 -1 -267 -20z"/>
<path d="M6482 9250 l11 -40 251 2 251 3 3 29 c2 16 -2 32 -10 37 -7 5 -126 9
-264 9 l-252 0 10 -40z"/>
<path d="M5576 9081 c-17 -18 -13 -49 8 -63 16 -11 526 -10 526 1 0 5 -7 25
-15 45 l-15 36 -244 0 c-224 0 -244 -1 -260 -19z"/>
<path d="M6471 9061 c-10 -22 -16 -42 -13 -45 3 -4 119 -6 259 -6 243 0 254 1
274 21 18 18 19 23 6 42 -14 21 -20 22 -260 25 l-246 2 -20 -39z"/>
<path d="M5273 8834 c-240 -35 -443 -139 -618 -318 -142 -146 -233 -305 -287
-506 -20 -73 -23 -109 -23 -255 0 -177 6 -219 51 -360 110 -345 416 -649 770
-763 178 -58 234 -63 716 -60 l438 3 -70 40 c-202 116 -542 350 -737 508 -233
187 -334 330 -364 515 -36 216 111 430 337 493 62 17 132 18 1088 19 562 1
1027 5 1033 8 11 8 133 234 270 503 l90 176 -216 6 c-119 4 -704 6 -1301 6
-851 -1 -1105 -4 -1177 -15z"/>
<path d="M5645 7440 c-3 -5 -2 -10 3 -10 15 0 1131 -673 1287 -776 268 -177
373 -293 436 -480 l24 -69 3 -677 c1 -373 5 -678 8 -678 3 0 24 10 47 21 374
189 644 531 739 938 25 111 36 379 19 489 -45 285 -161 538 -343 749 -167 193
-427 361 -678 436 -178 54 -208 56 -897 62 -440 4 -643 3 -648 -5z m2552
-1647 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m-67 -202 c7 -13
7 -28 0 -45 -13 -36 -24 -32 -16 7 4 20 3 27 -3 18 -5 -7 -14 -11 -20 -7 -7 5
-7 13 2 26 15 25 24 25 37 1z m-100 -200 c10 -24 9 -35 -8 -67 -19 -37 -19
-37 -24 -11 -3 15 -1 27 3 27 5 0 7 6 5 13 -1 6 -1 9 1 5 8 -14 23 -9 23 7 0
8 -4 15 -9 15 -5 0 -11 9 -14 20 -8 31 9 24 23 -9z m-99 -209 c-5 -9 -18 -25
-29 -35 -18 -17 -20 -17 -26 -1 -4 9 -4 19 -1 22 3 3 5 0 5 -6 0 -7 5 -12 11
-12 6 0 9 7 6 14 -4 10 -1 13 7 10 7 -3 16 2 19 10 4 9 9 16 12 16 3 0 1 -8
-4 -18z m-111 -107 c0 -7 -8 -17 -46 -60 -15 -16 -21 -22 -13 -11 7 10 14 25
15 33 4 25 44 60 44 38z m-126 -136 c-9 -11 -22 -19 -28 -19 -6 0 -4 6 5 13 9
7 14 18 12 25 -3 8 1 10 12 6 15 -6 14 -8 -1 -25z m-184 -95 c0 -2 -11 -4 -25
-4 -14 0 -25 4 -25 9 0 4 11 6 25 3 14 -2 25 -6 25 -8z m34 -9 c-16 -13 -33
-21 -38 -18 -5 3 -1 10 8 15 9 5 15 12 12 16 -2 4 7 8 21 9 l26 1 -29 -23z"/>
<path d="M6620 6355 c-11 -13 -10 -14 4 -9 9 3 27 -1 41 -10 35 -23 31 -12 -4
13 -25 18 -30 19 -41 6z"/>
<path d="M6548 6307 c-47 -32 -67 -58 -28 -37 25 13 26 2 3 -17 -17 -14 -17
-14 1 -8 11 3 23 0 27 -6 4 -6 6 4 5 22 -2 26 4 39 23 56 36 31 24 27 -31 -10z"/>
<path d="M6753 6275 c-6 -7 -9 -16 -5 -19 3 -4 0 -12 -8 -17 -12 -8 -10 -9 7
-4 12 3 33 1 45 -5 17 -9 15 -5 -7 14 -37 31 -25 33 24 5 l36 -21 -25 21 c-41
35 -54 40 -67 26z"/>
<path d="M6437 6223 c-4 -3 -7 -350 -7 -770 l0 -763 58 2 c35 1 44 3 25 5 -25
3 -33 9 -33 25 0 19 -1 19 -20 -3 -19 -24 -19 -22 -17 744 1 422 2 767 1 767
0 0 -4 -3 -7 -7z"/>
<path d="M6884 6204 c3 -9 -1 -14 -13 -14 -14 0 -18 -5 -14 -20 3 -11 9 -20
13 -20 5 0 12 9 15 20 3 11 11 20 16 20 14 0 11 -20 -3 -20 -8 0 -5 -7 6 -15
26 -19 42 -19 26 0 -29 34 31 4 72 -37 13 -13 14 -18 4 -18 -8 0 -16 7 -20 15
-7 19 -26 20 -26 2 0 -20 45 -41 71 -34 13 3 30 1 38 -6 14 -11 14 -10 2 6
-21 27 -194 139 -187 121z"/>
<path d="M5900 6038 c-146 -83 -306 -174 -356 -202 -50 -28 -98 -56 -107 -61
-16 -10 -17 -54 -17 -550 l0 -540 377 0 378 0 3 753 c1 413 -1 752 -5 752 -5
-1 -127 -69 -273 -152z"/>
<path d="M6450 6114 c0 -14 4 -23 10 -19 6 3 10 15 10 26 0 10 -4 19 -10 19
-5 0 -10 -12 -10 -26z"/>
<path d="M6960 6080 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6948 6063 c-37 -4 -38 -5 -36 -44 1 -22 5 -35 8 -28 6 8 9 8 14 0
10 -16 66 -14 66 3 0 7 3 28 6 45 5 23 3 31 -7 29 -8 -1 -31 -3 -51 -5z m-8
-33 c0 -11 -4 -20 -10 -20 -5 0 -10 9 -10 20 0 11 5 20 10 20 6 0 10 -9 10
-20z"/>
<path d="M7108 6038 c-7 -7 -19 -13 -25 -14 -44 -4 -43 0 -43 -104 0 -60 4
-100 10 -100 6 0 10 18 10 40 0 22 5 40 10 40 6 0 10 -18 10 -40 0 -33 3 -40
19 -40 16 0 21 8 24 43 2 23 4 -14 4 -83 0 -69 -2 -106 -4 -82 -3 34 -8 42
-24 42 -16 0 -19 -7 -19 -40 0 -57 -27 -55 -33 3 -2 23 -4 -29 -5 -115 -1
-100 2 -158 8 -158 6 0 10 7 10 15 0 8 5 15 10 15 6 0 10 -7 10 -15 0 -21 38
-19 43 3 3 9 4 -66 4 -168 l-1 -185 -3 163 c-3 154 -5 162 -23 162 -19 0 -20
-8 -20 -200 0 -127 -4 -200 -10 -200 -6 0 -10 31 -11 73 0 39 -4 95 -9 122 -6
42 -8 32 -9 -60 -1 -60 -4 -134 -7 -162 l-7 -53 31 0 c28 0 31 3 35 38 l4 37
1 -37 c3 -62 22 -43 24 25 1 34 5 -17 8 -113 3 -96 7 123 8 487 1 394 -2 664
-7 668 -5 3 -15 0 -23 -7z m-51 -440 c-2 -13 -4 -5 -4 17 -1 22 1 32 4 23 2
-10 2 -28 0 -40z"/>
<path d="M6473 5820 c0 -91 2 -146 4 -122 3 30 9 42 20 42 13 0 14 11 8 78 -4
42 -11 79 -15 82 -5 3 -10 23 -13 45 -2 22 -4 -34 -4 -125z"/>
<path d="M6520 5873 c0 -68 13 -133 26 -133 16 0 17 12 8 99 -5 41 -11 61 -20
61 -9 0 -14 -11 -14 -27z"/>
<path d="M4935 5585 c-121 -68 -299 -168 -395 -222 l-175 -98 -3 -293 -2 -292
405 0 405 0 0 515 c0 283 -3 515 -7 515 -5 -1 -107 -57 -228 -125z"/>
<path d="M6562 5618 c-2 -30 -6 -38 -21 -38 -15 0 -21 -8 -24 -37 l-4 -38 -1
38 c-2 29 -6 37 -21 37 -18 0 -19 -8 -16 -157 1 -87 0 -123 -2 -80 -5 102 -23
100 -23 -3 0 -44 4 -80 9 -80 6 0 12 -19 14 -42 l4 -43 1 43 c1 23 7 42 12 42
6 0 10 47 10 121 0 77 4 118 10 114 6 -4 10 -55 10 -121 0 -95 3 -114 15 -114
12 0 15 20 15 118 0 69 4 122 10 128 7 7 9 40 7 80 -1 38 -4 52 -5 32z"/>
<path d="M6560 5155 c0 -22 4 -25 40 -25 29 0 40 -4 40 -15 0 -11 -11 -15 -40
-15 l-40 0 0 -40 0 -40 160 0 160 0 0 80 0 80 -160 0 -160 0 0 -25z"/>
<path d="M7042 4823 c-2 -34 -9 -49 -44 -84 l-42 -42 -155 5 c-86 2 -176 1
-201 -3 -25 -3 87 -7 248 -7 160 -1 292 1 292 6 0 4 -20 6 -45 4 l-45 -4 0 36
c0 33 2 36 19 26 42 -22 51 -14 51 45 0 48 -2 55 -20 55 -17 0 -20 -7 -20 -40
0 -57 -27 -55 -33 3 l-4 42 -1 -42z"/>
<path d="M3140 4001 c-105 -34 -160 -106 -160 -210 0 -119 52 -170 234 -227
97 -30 126 -50 126 -88 0 -38 -10 -56 -41 -71 -57 -30 -147 -11 -221 47 l-36
28 -42 -50 c-24 -29 -40 -56 -36 -65 17 -46 173 -115 260 -115 59 0 139 23
180 51 111 76 115 266 8 343 -20 14 -80 40 -133 56 -111 35 -149 60 -149 98 0
33 8 45 37 61 40 21 107 13 168 -19 31 -16 60 -30 64 -30 12 1 72 102 68 114
-3 6 -35 27 -72 46 -57 29 -78 34 -148 37 -45 1 -93 -1 -107 -6z"/>
<path d="M3800 3630 l0 -370 75 0 75 0 0 370 0 370 -75 0 -75 0 0 -370z"/>
<path d="M4240 3988 c1 -7 61 -173 134 -368 l132 -355 71 -3 70 -3 131 353
c72 194 134 361 137 371 6 15 -1 17 -72 17 l-80 0 -38 -102 c-21 -57 -57 -159
-80 -228 -24 -69 -48 -138 -55 -155 l-12 -30 -27 75 c-15 41 -56 157 -91 257
l-65 183 -77 0 c-56 0 -78 -4 -78 -12z"/>
<path d="M5290 3843 c-102 -258 -220 -564 -220 -574 0 -5 33 -9 74 -9 l74 0
30 78 29 77 149 0 149 0 26 -75 26 -75 78 -3 77 -3 -7 28 c-3 15 -24 73 -46
128 -21 55 -80 208 -131 340 l-93 240 -76 3 -76 3 -63 -158z m183 -163 l45
-115 -44 -3 c-24 -2 -65 -2 -92 0 l-49 3 39 105 c21 58 41 111 44 119 7 20 7
18 57 -109z"/>
<path d="M6485 3633 l0 -368 145 -3 c153 -3 228 7 293 40 161 82 229 289 156
482 -28 78 -86 138 -168 179 l-65 32 -181 3 -180 4 0 -369z m356 204 c24 -13
57 -42 73 -65 26 -36 30 -53 34 -124 3 -76 1 -88 -25 -138 -40 -79 -89 -104
-203 -105 l-85 0 -3 228 -2 227 83 0 c68 0 92 -4 128 -23z"/>
<path d="M7555 3853 c-140 -356 -225 -578 -225 -585 0 -5 35 -8 77 -6 l77 3
27 75 27 75 148 3 149 2 29 -80 28 -80 75 0 75 0 -7 27 c-6 24 -131 354 -234
613 l-37 95 -75 3 -76 3 -58 -148z m146 -80 c6 -16 26 -70 45 -120 l34 -93
-90 0 c-65 0 -90 3 -90 12 0 15 81 228 87 228 2 0 8 -12 14 -27z"/>
<path d="M8202 3933 l3 -68 98 -3 97 -3 0 -299 0 -300 75 0 75 0 0 300 0 300
100 0 100 0 0 70 0 70 -275 0 -276 0 3 -67z"/>
<path d="M9181 3978 c-5 -13 -39 -99 -76 -193 -37 -93 -98 -250 -135 -347
l-68 -178 78 0 78 0 28 80 27 80 148 0 147 0 18 -47 c9 -27 23 -63 30 -80 l13
-33 75 0 c46 0 76 4 76 10 0 11 -44 126 -192 503 l-90 227 -74 0 c-68 0 -75
-2 -83 -22z m131 -300 l44 -113 -89 -3 c-49 -1 -91 -1 -93 1 -6 5 80 227 87
227 3 0 26 -51 51 -112z"/>
<path d="M5166 2838 c-9 -12 -16 -32 -16 -44 0 -14 -8 -24 -21 -27 -23 -6 -17
-27 7 -27 11 0 14 -18 14 -85 0 -68 3 -85 15 -85 11 0 15 18 17 82 3 76 5 83
26 88 33 7 32 24 -1 28 -24 3 -28 7 -25 30 2 21 9 28 31 30 38 5 36 32 -2 32
-20 0 -35 -8 -45 -22z"/>
<path d="M2990 2844 c0 -4 14 -29 30 -56 17 -26 30 -52 30 -57 0 -5 7 -14 15
-21 9 -7 15 -35 17 -73 2 -50 6 -62 21 -65 14 -3 17 5 17 53 0 48 6 67 46 136
25 45 43 83 40 86 -13 13 -37 -10 -68 -66 -35 -65 -43 -71 -52 -43 -12 37 -66
112 -81 112 -8 0 -15 -3 -15 -6z"/>
<path d="M4766 2842 c-9 -14 12 -35 28 -29 23 9 20 37 -3 37 -11 0 -22 -4 -25
-8z"/>
<path d="M6010 2829 c0 -14 5 -19 17 -17 26 5 29 38 4 38 -15 0 -21 -6 -21
-21z"/>
<path d="M6800 2835 c0 -21 30 -31 40 -14 11 17 3 29 -21 29 -10 0 -19 -7 -19
-15z"/>
<path d="M8562 2833 c5 -26 38 -29 38 -4 0 15 -6 21 -21 21 -14 0 -19 -5 -17
-17z"/>
<path d="M9134 2839 c-9 -15 11 -33 30 -26 9 4 13 13 10 22 -7 17 -30 20 -40
4z"/>
<path d="M4597 2823 c-4 -3 -7 -17 -7 -30 0 -13 -6 -23 -14 -23 -24 0 -30 -21
-7 -27 19 -5 21 -13 21 -68 0 -35 3 -71 6 -80 10 -24 51 -37 76 -24 23 13 14
26 -22 31 -24 3 -25 7 -28 71 l-3 67 31 0 c20 0 30 5 30 15 0 10 -10 15 -30
15 -27 0 -30 3 -30 30 0 29 -9 38 -23 23z"/>
<path d="M5836 2823 c-3 -3 -6 -17 -6 -30 0 -13 -6 -23 -14 -23 -24 0 -30 -21
-7 -27 18 -4 21 -14 23 -81 3 -71 5 -78 28 -89 29 -14 73 -7 67 11 -2 6 -17
13 -33 16 -28 5 -29 7 -32 73 l-3 67 31 0 c20 0 30 5 30 15 0 10 -10 15 -30
15 -25 0 -30 4 -30 24 0 26 -12 40 -24 29z"/>
<path d="M9281 2808 c3 -27 -2 -38 -16 -38 -8 0 -15 -7 -15 -15 0 -8 7 -15 15
-15 11 0 15 -13 15 -54 0 -30 4 -66 10 -81 16 -41 90 -57 90 -19 0 9 -11 14
-30 14 l-30 0 0 70 0 70 31 0 c38 0 35 24 -4 28 -21 3 -27 9 -27 28 0 18 -5
24 -20 24 -12 0 -20 -6 -19 -12z"/>
<path d="M3279 2741 c-52 -52 -34 -147 32 -170 71 -25 131 19 133 95 1 40 -3
49 -32 75 -44 40 -93 40 -133 0z m115 -23 c20 -29 20 -67 0 -96 -23 -33 -83
-27 -103 9 -16 29 -10 69 15 93 23 24 70 20 88 -6z"/>
<path d="M3530 2686 c0 -80 1 -86 27 -106 20 -15 34 -19 53 -14 14 4 37 7 53
6 l27 -1 0 99 c0 82 -3 100 -15 100 -12 0 -15 -15 -15 -75 0 -68 -2 -76 -25
-91 -23 -15 -27 -15 -50 0 -23 15 -25 23 -25 91 0 60 -3 75 -15 75 -12 0 -15
-16 -15 -84z"/>
<path d="M3790 2670 c0 -82 3 -100 15 -100 12 0 15 14 15 63 0 69 18 107 51
107 10 0 19 7 19 15 0 18 -41 20 -58 3 -9 -9 -12 -9 -12 0 0 7 -7 12 -15 12
-12 0 -15 -18 -15 -100z"/>
<path d="M4112 2754 c-47 -32 -18 -87 53 -102 48 -10 58 -36 21 -53 -21 -10
-30 -9 -51 5 -28 18 -61 15 -49 -5 3 -6 22 -18 41 -26 47 -19 100 -3 109 34 9
35 -6 55 -54 73 -49 18 -67 34 -58 49 9 14 63 14 71 1 9 -15 35 -12 35 5 0 34
-79 47 -118 19z"/>
<path d="M4345 2750 c-22 -24 -12 -39 15 -22 29 18 68 15 79 -7 13 -24 5 -31
-38 -31 -52 0 -81 -23 -81 -64 0 -39 20 -59 58 -58 15 1 44 2 65 3 l37 1 0 79
c0 66 -3 82 -20 99 -27 27 -90 27 -115 0z m98 -97 c3 -5 1 -18 -4 -30 -10 -27
-53 -40 -74 -23 -18 15 -20 46 -2 53 19 8 75 8 80 0z"/>
<path d="M4777 2763 c-4 -3 -7 -49 -7 -100 0 -83 2 -94 17 -91 20 4 24 32 17
126 -5 67 -11 81 -27 65z"/>
<path d="M4917 2752 c-36 -40 -15 -78 52 -97 25 -8 37 -17 39 -32 5 -31 -39
-41 -74 -18 -16 10 -30 13 -35 8 -14 -14 23 -43 62 -49 46 -8 91 27 87 64 -3
27 -19 38 -86 63 -21 8 -32 17 -30 28 4 21 44 26 74 10 31 -16 42 -4 19 21
-24 26 -85 27 -108 2z"/>
<path d="M5329 2751 c-28 -22 -18 -41 11 -23 38 24 90 9 90 -25 0 -8 -14 -13
-39 -13 -65 0 -111 -54 -83 -97 14 -21 60 -33 88 -22 15 5 35 7 45 4 18 -6 19
0 19 79 0 76 -2 86 -22 100 -31 22 -81 20 -109 -3z m101 -110 c0 -22 -35 -51
-62 -51 -9 0 -22 9 -28 21 -16 30 4 49 51 49 32 0 39 -4 39 -19z"/>
<path d="M5580 2743 c-25 -23 -31 -36 -32 -70 -1 -98 86 -145 154 -84 30 27
31 30 14 37 -13 5 -23 2 -31 -9 -7 -10 -26 -17 -43 -17 -36 0 -62 30 -62 72 0
53 69 90 100 53 16 -19 40 -19 40 -1 0 22 -40 46 -77 46 -22 0 -43 -9 -63 -27z"/>
<path d="M6017 2764 c-4 -4 -7 -50 -7 -101 0 -85 2 -94 18 -91 15 3 17 16 17
97 0 88 -8 115 -28 95z"/>
<path d="M6165 2748 c-53 -47 -41 -148 21 -174 114 -48 197 100 100 178 -30
25 -89 23 -121 -4z m109 -27 c26 -29 18 -89 -15 -114 -24 -17 -30 -18 -55 -6
-24 12 -29 21 -32 58 -2 30 2 49 14 62 22 24 66 24 88 0z"/>
<path d="M6410 2670 c0 -82 3 -100 15 -100 12 0 15 14 15 63 0 72 18 107 55
107 37 0 55 -35 55 -107 0 -49 3 -63 15 -63 12 0 15 16 15 80 0 67 -3 83 -20
100 -23 23 -79 27 -99 8 -11 -10 -14 -10 -18 0 -3 6 -11 12 -19 12 -11 0 -14
-20 -14 -100z"/>
<path d="M6810 2670 c0 -82 3 -100 15 -100 12 0 15 18 15 100 0 82 -3 100 -15
100 -12 0 -15 -18 -15 -100z"/>
<path d="M6958 2753 c-40 -47 -28 -77 35 -94 57 -15 69 -26 56 -50 -12 -23
-48 -25 -75 -4 -24 18 -44 19 -44 1 0 -16 58 -46 89 -46 23 0 71 41 71 60 0
28 -24 50 -70 65 -37 12 -50 21 -48 33 4 20 46 28 61 13 13 -13 47 -14 47 -2
0 17 -44 41 -76 41 -17 0 -38 -8 -46 -17z"/>
<path d="M7319 2741 c-23 -24 -29 -38 -29 -73 1 -47 11 -65 52 -92 37 -24 90
-14 118 21 23 29 27 108 7 134 -36 47 -105 52 -148 10z m115 -23 c20 -29 20
-67 0 -96 -24 -34 -84 -28 -102 11 -25 52 6 107 58 107 18 0 34 -8 44 -22z"/>
<path d="M7569 2763 c-1 -5 0 -44 1 -88 2 -89 12 -108 57 -107 15 1 45 2 66 3
l37 1 0 99 c0 81 -3 99 -15 99 -12 0 -15 -15 -15 -75 0 -69 -2 -76 -25 -91
-21 -14 -31 -15 -50 -6 -24 11 -25 16 -25 92 0 64 -3 80 -15 80 -8 0 -15 -3
-16 -7z"/>
<path d="M7820 2670 c0 -82 3 -100 15 -100 12 0 15 14 15 63 0 68 18 107 50
107 10 0 22 5 25 10 10 17 -26 24 -48 10 -15 -9 -22 -10 -25 -1 -2 6 -10 11
-18 11 -11 0 -14 -20 -14 -100z"/>
<path d="M8124 2757 c-2 -7 -3 -71 -2 -142 3 -114 5 -130 21 -133 14 -3 17 5
17 52 l0 56 25 -16 c31 -20 68 -12 101 23 56 61 12 173 -68 173 -19 0 -39 -5
-45 -11 -8 -8 -13 -8 -17 0 -10 15 -26 14 -32 -2z m131 -37 c23 -26 25 -85 3
-106 -19 -20 -62 -21 -83 -4 -18 15 -20 101 -3 118 19 19 63 14 83 -8z"/>
<path d="M8397 2763 c-4 -3 -7 -48 -7 -100 0 -76 3 -93 15 -93 11 0 15 11 15
38 0 81 11 114 42 126 15 6 28 16 28 23 0 17 -32 17 -49 1 -11 -10 -14 -10
-18 0 -5 13 -16 16 -26 5z"/>
<path d="M8570 2670 c0 -82 3 -100 15 -100 12 0 15 18 15 100 0 82 -3 100 -15
100 -12 0 -15 -18 -15 -100z"/>
<path d="M8740 2763 c-53 -19 -69 -125 -26 -168 34 -34 68 -40 109 -20 39 18
57 50 57 101 0 67 -72 111 -140 87z m85 -37 c29 -21 27 -92 -4 -117 -31 -25
-47 -24 -76 6 -64 63 9 163 80 111z"/>
<path d="M8960 2668 c0 -80 3 -98 15 -98 12 0 15 14 15 63 0 69 18 107 51 107
10 0 19 6 19 14 0 10 -14 13 -50 13 l-50 -1 0 -98z"/>
<path d="M9140 2670 c0 -82 3 -100 15 -100 12 0 15 18 15 100 0 82 -3 100 -15
100 -12 0 -15 -18 -15 -100z"/>
<path d="M9450 2760 c0 -6 16 -50 35 -98 40 -98 40 -138 -1 -148 -31 -8 -32
-34 -1 -34 36 0 52 25 96 145 21 61 42 118 46 128 5 12 2 17 -9 17 -17 0 -34
-31 -58 -108 -7 -23 -15 -42 -18 -42 -3 0 -18 34 -33 75 -17 46 -34 75 -43 75
-8 0 -14 -5 -14 -10z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
